var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-area rounded-lg p-4"},[(_vm.headline)?_c('h5',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.headline))]):_vm._e(),_c('form-builder',{staticClass:"form-wizard",attrs:{"state-machine":_vm.stateMachine,"components-list":_vm.componentsList,"custom-validators":{}},on:{"submit":_vm.nextStep}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }